// extracted by mini-css-extract-plugin
module.exports = {"container":"_2MWRz","post":"_25pqr","hashtags":"_3grc-","separator":"_1_GJ_","content":"_3ysma"};